import { multiplyMoney } from '@shared/lib/money';
import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment, Money } from '@websky/graphql';
import { useMemo } from 'react';
import { State } from './types';

export const useVariables = (state: State, service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment) => {
	const totalPrice = useMemo<Money>(() => {
		let count = 0;

		for (const [passengerId] of Object.keys(state)) {
			for (const [segmentId] of Object.keys(state[passengerId])) {
				if (state[passengerId][segmentId]?.selected && !state[passengerId][segmentId]?.confirmed) {
					count += 1;
				}
			}
		}

		return multiplyMoney(service.price, count);
	}, [state]);

	return {
		totalPrice,
		minPrice: service.price
	};
};
